export { default } from "./Platforms";
